import * as KaikoAction from "./KaikoAction";

export default function kaikoReducer(state = {}, action) {
    switch (action.type) {
        case KaikoAction.REQUEST_EXCHANGES_FINISHED:
        case KaikoAction.REQUEST_BASE_CURRENCIES_FINISHED:
        case KaikoAction.REQUEST_PRICING_PACKAGES_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else 
            {
                return {
                    ...state,
                    ...action.payload
                };
            }
        case KaikoAction.REQUEST_FILES_INFO_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else 
            {
                return {
                    ...state,
                    filesInfo: action.payload
                };
            }
        case KaikoAction.REQUEST_SUBSCRIPTION_FILES_INFO_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscriptionFilesInfo: action.payload
                };
            }
        case KaikoAction.REQUEST_SUBSCRIPTION_PRICING_PACKAGES_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscriptionPricingPackages: action.payload
                };
            }
        default:
            return state;
    }
}
